var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from "react";
var getValueByPath = function (obj, path) {
    return path.split(".").reduce(function (acc, part) { return acc === null || acc === void 0 ? void 0 : acc[part]; }, obj);
};
var sortData = function (data, sortMethod, sortDirection) {
    var sortable = __spreadArray([], data, true);
    sortable.sort(function (a, b) {
        var aVal = getValueByPath(a, sortMethod);
        var bVal = getValueByPath(b, sortMethod);
        if (aVal < bVal)
            return -1 * sortDirection;
        if (aVal > bVal)
            return 1 * sortDirection;
        if (a.id < b.id)
            return -1 * sortDirection;
        if (a.id > b.id)
            return 1 * sortDirection;
        return 0;
    });
    return sortable;
};
export var useSortedData = function (data, sort, sortDirection) {
    var _a = useState(data), sortedData = _a[0], setSortedData = _a[1];
    var _b = useState(sort), sortMethod = _b[0], setSortMethod = _b[1];
    var _c = useState(sortDirection), sortDir = _c[0], setSortDirection = _c[1];
    useEffect(function () {
        if (sortMethod && sortDir) {
            setSortedData(sortData(data, sortMethod, sortDir));
        }
    }, [sortMethod, sortDir]);
    var setSort = function (method, direction) {
        setSortMethod(method);
        setSortDirection(direction);
    };
    return {
        sortedData: sortedData,
        sortMethod: sortMethod,
        sortDirection: sortDir,
        setSort: setSort,
    };
};
